"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormularioAtributoOpcao = void 0;
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
const typeorm_1 = require("typeorm");
let FormularioAtributoOpcao = class FormularioAtributoOpcao extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdOpcao = void (0);
        this.cdFormularioAtributo = void (0);
        this.txtOpcao = void (0);
        this.vlReferencia = void (0);
        this.idOpcao = void (0);
        this.nrOrdem = void (0);
    }
};
__decorate([
    typeorm_1.Column('integer', { name: 'cd_opcao', nullable: true, primary: true }),
    __metadata("design:type", Number)
], FormularioAtributoOpcao.prototype, "cdOpcao", void 0);
__decorate([
    typeorm_1.Column('integer', { name: 'cd_formulario_atributo', nullable: true }),
    __metadata("design:type", Number)
], FormularioAtributoOpcao.prototype, "cdFormularioAtributo", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'txt_opcao', nullable: true }),
    __metadata("design:type", String)
], FormularioAtributoOpcao.prototype, "txtOpcao", void 0);
__decorate([
    typeorm_1.Column('float', { name: 'vl_referencia', nullable: true }),
    __metadata("design:type", Number)
], FormularioAtributoOpcao.prototype, "vlReferencia", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'id_opcao', nullable: true }),
    __metadata("design:type", String)
], FormularioAtributoOpcao.prototype, "idOpcao", void 0);
__decorate([
    typeorm_1.Column('integer', { name: 'nr_ordem', nullable: true }),
    __metadata("design:type", Number)
], FormularioAtributoOpcao.prototype, "nrOrdem", void 0);
FormularioAtributoOpcao = __decorate([
    typeorm_1.Entity('grl_formulario_atributo_opcao')
], FormularioAtributoOpcao);
exports.FormularioAtributoOpcao = FormularioAtributoOpcao;
